<template>
    <div class="dataWZD">
        <el-dialog :visible.sync="centerDialogVisible" custom-class="dialogQy" :show-close="false" destroy-on-close
            :modal="false" :close-on-click-modal="false" width="430px" center>
            <div>
                <div class="dialog_title_tet">
                    <div class="flex_title">
                        <span class="fengexian"></span>
                        <span class="title_tet">物资点1</span>
                        <span class="fengexian"></span>
                    </div>
                </div>
                <div class="dialog-title">
                    <div class="dialog-titel-item">
                        <div class="child">物资点: 火灾救援物资点1</div>
                        <div class="child">物资总数: 10</div>
                    </div>
                    <div class="dialog-titel-item">
                        <div class="child">所在位置: 大洋街道大洋3栋101号</div>
                        <div class="child">位置坐标: 15.203.160.21</div>
                    </div>

                </div>
                
                <el-table :data="tableData" class="tableBox"  v-loading="loading"
                    style="width: 100%">
                    <el-table-column align="center" prop="name" label="物资名称"></el-table-column>
                    <el-table-column align="center" prop="type" width="50" label="物资类型"></el-table-column>
                    <el-table-column align="center" prop="num" width="50" label="物资数量"></el-table-column>
                    <el-table-column align="center" prop="time" label="过期时间"></el-table-column>
                    <el-table-column align="center" prop="name" label="保障企业"></el-table-column>
                    <el-table-column align="center" prop="phone" label="联系电话"></el-table-column>
                </el-table>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" class="footer-btn" @click="centerDialogVisible = false">关闭</el-button>
            </span>

        </el-dialog>
    </div>
</template>

<script>
    import drawMixin from "@/utils/drawMixin";


    export default {
        mixins: [drawMixin],
        data() {
            return {
                centerDialogVisible: false,
                loading: false,
                tableData: [
                    { name: '干粉灭火器', type: '器材', num: '2', time: '2024-12-12', bzqy: 'XX保障企业1', phone: '18896001215' },
                    { name: '软胶水管', type: '器材', num: '1', time: '2024-12-12', bzqy: 'XX保障企业1', phone: '18896001215' },
                    { name: '警示标识', type: '工具', num: '3', time: '2024-12-12', bzqy: 'XX保障企业1', phone: '18896001215' },
                    { name: '专用救援绳', type: '工具', num: '6', time: '2024-12-12', bzqy: 'XX保障企业1', phone: '18896001215' },
                    { name: '钢筋剪', type: '工具', num: '2', time: '2024-12-12', bzqy: 'XX保障企业1', phone: '18896001215' },
                    { name: '钢丝绳', type: '绳索', num: '2', time: '2024-12-12', bzqy: 'XX保障企业1', phone: '18896001215' },


                ],
            };
        },
        components: {

        },
        mounted() {


        },
        beforeDestroy() {

        },
        created() { },
        methods: {
            init(row) {
                this.centerDialogVisible = true
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../assets/scss/index.scss";

    .dataWZD {

        ::v-deep .dialogQy {
            background: linear-gradient(180deg, #02265B 0%, #34639A 100%);
            border: 1px solid #4A72A2;

            .el-dialog__header {
                padding: 0;
            }

            .el-dialog__body {
                padding: 0 !important;
            }


            .dialog_title_tet {
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 12px;
                color: #FFFFFF;
                margin-bottom: 10px;
                padding-top: 10px;

                .flex_title {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .fengexian {
                        width: 20px;
                        height: 1px;
                        background-color: #CBE2F6;
                    }

                    .title_tet {
                        margin: 0 10px;
                    }
                }

            }

            .dialog-title {
                padding: 10px;
                padding-bottom: 0;
            }

            .dialog-titel-item {
                display: flex;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 12px;
                color: #FFFFFF;
                margin-bottom: 10px;

                .child {
                    flex: 1,
                }
            }

            .deatl {
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 12px;
                color: #BFDDFF;

                .deatl-item {
                    display: flex;
                    height: 27px;

                    >div {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }

                .deatl-item-title {
                    background: linear-gradient(180deg, #1F4277 0%, #34639A 100%);
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #9FD9FF;
                    box-sizing: border-box;
                }

                .deatl-item {
                    border-bottom: 1px solid #4A72A2;
                    ;
                }
            }

            .el-dialog__footer {
                padding-bottom: 10px;
            }

            .tableBox {
                background: none;

                tr {
                    background: none;

                    th {
                        background: none;
                        color: #9FD9FF;
                        font-size: 12px;
                        padding: 11px 0;

                        .cell {
                            padding: 0;
                        }
                    }

                    td {
                        border: none;
                        border-bottom: 1px solid #4A72A2;
                        border-left: none;
                        border-right: none;
                        font-size: 12px;
                        
                        .cell {
                            padding: 0;
                        }
                    }
                }
            }
            .el-table::before {
                background: none;
            }

            .dialog-footer {

                .footer-btn {
                    width: 116px;
                    height: 28px;
                    border-radius: 0;
                    background: linear-gradient(180deg, #1F4277 0%, #34639A 100%);
                    border: 1px solid #9FD9FF;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 14px;
                    color: #9FD9FF;
                    padding: 0;

                }
            }
        }
    }

    /* 自定义滚动条整体样式 */
    ::-webkit-scrollbar {
        height: 3px !important;
    }

    /* 自定义滚动条滑块样式 */
    ::-webkit-scrollbar-thumb {
        /* background-color: #888; */
        /* 设置滑块的颜色 */
        /* 设置滑块的圆角 */
        background: #B7CDF3;
        border-radius: 3px;
    }

    /* 自定义滚动条轨道样式 */
    ::-webkit-scrollbar-track {
        /* background-color: #f0f0f0; */
        background: #748EBB;
        /* 设置轨道的颜色 */
    }
</style>